import { useState, useRef } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

 
import InputPagger from "../../helpers/InputPagger";
import InputDateTime from "../../helpers/InputDateTime";
import SortBy from "../../helpers/SortBy";

 
 

function History(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        r_imie_nazwisko: '', 
        data_od: '', 
        data_do: '', 
        fraza: '', 

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1,history', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(filterParam[filedName] != val && val.length == 0)
        setTab(null);  
    }



    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterClear = () => {
        setFilterParam({
            r_imie_nazwisko: '', 
            data_od: '', 
            data_do: '', 
            fraza: '',    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            
            limit: 50,
            page: 1,
        });
        setTab(null);
    }


    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
    }





    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }


    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }

   

    var sortList = [  
        {column: "created_at", name: "Data wpisu"  }, 
    ]
 
    

    return (

        <div className="view_content">
         


            <div className="table_filter">
               
                           <div className="filter_controll">   
                                <label>Nazwisko, imię: </label>                             
                                <InputText   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Nazwisko, imię: "}   />
                            </div>  


                            <div className="filter_controll">   
                                <label>Tytuł / fraza: </label>                             
                                <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Tytuł / fraza: "}   />
                            </div> 

                         
                            <div className="filter_controll filter_merge">   
                                <label>Data od / do: </label>      <br/>                       
                                <InputDateTime   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}  className="w200" />                                                                  
                                <InputDateTime   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}  className="w200"  />
                            </div> 

                            <div className="filter_btn">
                                    <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>
                         

            </div>



            <div className="bg_center">


                    <div className="table_widget">                     
                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />
                    </div>
 


                            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td className="">Kto</td>
                                                <td className="">Tytuł</td>
                                                <td className="">Szczegóły</td>
                                                <td className="">Data</td>
                                                
                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td className="goleft">{row.nazwisko + " " + row.imie}</td>
                                                            <td className="goleft">{row.tytul}</td>
                                                            <td className="goleft">{row.szczegoly}</td>
                                                            <td className="gocenter">{row.data}</td>                                                                
                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>

            </div>


        </div>

    )

}

export default History;